<template>
  <div class="input-text-wrapper">
    <div class="input-text-container">
      <input
        ref="input"
        class="input-text input-text--copy"
        type="text"
        :value="value"
        :placeholder="placeholder"
        :disabled="isDisabled"
        :maxlength="limit"
        readonly
        v-bind="$attrs"
      />

      <button
        type="button"
        class="input-text__copy"
        :disabled="isDisabled"
        @click="handleCopy"
      >
        <CheckIcon v-if="copied" />
        <CopyIcon v-else />
      </button>
    </div>
  </div>
</template>

<script>
import { Clipboard } from '@/shared/lib/clipboard';
import { CheckIcon, CopyIcon } from '@/shared/ui/icons';

const clipboard = Clipboard();

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      copied: false,
      copyTimeout: null,
    };
  },
  beforeDestroy() {
    if (this.copyTimeout) {
      clearTimeout(this.copyTimeout);
    }
  },
  components: { CopyIcon, CheckIcon },
  methods: {
    handleCopy() {
      if (!this.value) return;

      clipboard.copy(String(this.value));
      this.copied = true;
      this.$emit('copy', this.value);

      this.copyTimeout = setTimeout(() => {
        this.copied = false;
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-text-wrapper {
  width: 100%;
}

.input-text-container {
  position: relative;
  width: 100%;
}

.input-text {
  background-color: #ffffff;
  border: 1px solid #E4E4E7;
  border-radius: 6px;
  font-family: 'Geist', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #09090B;
  padding: 8px 12px;
  width: 100%;

  &::placeholder {
    color: #D4D4D8;
  }

  &--copy {
    padding-right: 44px;
  }

  &--disabled {
    background-color: #F6F6F9;
  }
}

.input-text__copy {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #71717A;
  transition: color 0.2s;

  &:hover:not(:disabled) {
    color: #6171E4;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    display: block;
    transition: color 0.2s;
  }
}
</style>
